import * as TemplateActionTypes from '../../../constants/contents/TemplateActionTypes';

const initialState = {
    items: [],
    totalCount: null
};

const itemUpdate = (items, id, values) => items.map(item => {
	if (item.id === id) {
		item = Object.assign({}, item, values)
	}
	return item
})

const updatedItems = (state, id, values) => Object.assign({}, state, {
	items: itemUpdate(state.items, id, values)
})

const selectedItems = (items, id, select) => items.map(item => {
    if (item.id === id) {
        item = Object.assign({}, item, { selected: select })
    }
    return item
});

export default (state = initialState, action) => {
	switch (action.type) {
		case TemplateActionTypes.CLEAR_ITEMS:
            return {
                items: [],
                totalCount: null,
            }
		case TemplateActionTypes.RECEIVE_ITEMS:
			return {
				items: action.items,
				totalCount: action.totalCount
			}
		case TemplateActionTypes.SELECT_ITEM:
			return updatedItems(state, action.id, { selected: true })

		case TemplateActionTypes.DESELECT_ITEM:
			return updatedItems(state, action.id, { selected: false })

		case TemplateActionTypes.SELECT_ALL_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => {
					if ( item.editable) {
                    	item = Object.assign({}, item, { selected: true })
                    }
					return item
				})
			})
		case TemplateActionTypes.DESELECT_ALL_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => Object.assign({}, item, { selected: false }) )
			})
		case TemplateActionTypes.UPDATE_ITEM:
			return updatedItems(state, action.item.id, action.item)

		case TemplateActionTypes.UPDATE_SELECTED_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => {
					if (item.selected) {
						item = Object.assign({}, item, action.values)
					}
					return item
				})
			})

	}
	return state
}
